import { EmailContext } from "../types";

export const MOCK_EMAIL_CONTEXT: EmailContext = {
  messageId: "mock-id-001",
  subject: "Re: Q3 Partnership Proposal",
  body: "Hi Sarah,\n\nFollowing up on our discussion from last week regarding the Q3 partnership terms. We'd really like to move forward and need to finalize the contract details by Friday.\n\nCould we schedule a 30-minute call this week to align on the pricing structure?\n\nLooking forward to your response.\n\nBest,\nAlex",
  sender: "Sarah K.",
  senderEmail: "sarah.k@acmecorp.com",
  userName: "Alex",
  userEmail: "alex@yourcompany.com",
  receivedAt: new Date().toISOString(),
  threadLength: 3,
  recipientName: "Sarah K.",
  opportunityLabel: "Active opportunity",
  engagementLabel: "Moderately engaged",
  // In dev mode the mock simulates a reply draft being open
  isCompose: true,
  hasDraft: true,
  isReply: true,
  draftSubject: "Re: Q3 Partnership Proposal",
  draftBody: "Hi Sarah,\n\nI wanted to reach out and follow up on the proposal. Looking forward to hearing from you.\n\nBest,\nAlex",
};
